import React, { useEffect, useState ,useMemo} from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import {
  downloadCSV,
  fetchDataCallOnInitialLoad,
} from "../../../common_nextgen/utils/UtilFunctions";

const useCopayScheduleStep = (
  onSelect,
  hideModal,
  initialSelectParams,
  intialSelectMode,
  initialLookupType,
  selectParamsData,
  setFalg,
  intialSchedule,
  paramsDesc,
  sourceData,
  scheduleDesc,
  onNavigate,
  initialSelectedCopaySchedules=[]
) => {
  const { axios_helper_no_header } = useAxios();
  const location = useLocation();
  const [selectMode, setSelectedMode] = useState(intialSelectMode);
  const [lookupType, setLookupType] = useState(initialLookupType);
  const [selectParams, setSelectParams] = useState(initialSelectParams);
  const [data, setData] = useState([]); /* Copay Schedule Step Data */
  const [stateVal, setStateVal] = useState(location.state || []);
  const { currentState, previousState } = useMemo(() => {
    let [currentState = {}] = [...stateVal].reverse();
    const previousState = [...stateVal];
    previousState.splice(stateVal.length - 1, 1);
    return {
      previousState,
      currentState,
    };
  }, [stateVal]);
  
  
 
  console.log("current state in form", currentState, previousState);
  const {
    selectedSchedules = [],
    previousScreen = ROUTE_PATHS.COPAY_SCHEDULE,
    currentIndex: initialIndex = 0,
    paramsData: initialParamsData = {
      cscCopayScheduleName: selectedSchedules[initialIndex]?.cshCopayScheduleId,
      cshCopayScheduleDesc:
        selectedSchedules[initialIndex]?.cshCopayScheduleDesc,
      cscStepNbr: null,
    },
    interLinkedLookup: initialInterLinkedLookup = null,
    externalMode: initialExternalMode = false,
  } = useMemo(() => {
    const {
      selectedSchedules ,
      previousScreen = ROUTE_PATHS.COPAY_SCHEDULE,
      currentIndex,
      paramsData,
      interLinkedLookup ,
      externalMode, 
  }=currentState;
  return{
    selectedSchedules ,
    previousScreen,
    currentIndex,
    paramsData,
    interLinkedLookup ,
    externalMode, 
  }
},[currentState]);

  const [externalMode, setExternalMode] = useState(initialExternalMode);
  const [interLinkedLookup, setInterLinkedLookup] = useState(initialInterLinkedLookup)

  const baseParamsData = lookupType
    ? {
        cscCopayScheduleName: scheduleDesc?.cshCopayScheduleId,
        cshCopayScheduleDesc: scheduleDesc?.cshCopayScheduleDesc,
        cscStepNbr: scheduleDesc?.cscStepNbr
          ? Number(scheduleDesc?.cscStepNbr)
          : null,
      }
    : initialParamsData;
  console.log("base params", baseParamsData);
  const [paramsData, setParamsData] = useState(baseParamsData);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [selectedPatient, setSelectedPatient] = useState(
    initialSelectedCopaySchedules
  );
  const toast = useToast();
  const {
    ADD_COPAY_SCHEDULE_STEP,
    EDIT_COPAY_SCHEDULE_STEP,
    DISPLAY_COPAY_SCHEDULE_STEP,
    COPY_COPAY_SCHEDULE_STEP,
    COPAY_SCHEDULE_NOTE,
  } = ROUTE_PATHS;

  const screen_title = "Copay Schedule Step";
  const [screenNumber, setScreenNumber] = useState("RCCSC005");

  const fetchScheduleDescription = async (scheduleId) => {
    try {
      const response = await axios_helper_no_header(
        "GET",
        `api/cshCopayScheduleHeader`,
        null,
        {
          page: 0,
          size: 1,
          cshCopayScheduleId: scheduleId,
        }
      );
      const description =
        response?.responseData?.[0]?.cshCopayScheduleDesc || "";
      return description;
    } catch (error) {
      console.error("Error fetching schedule description:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to fetch schedule description",
        life: 3000,
      });
      return "";
    }
  };

  const initializeDescription = async () => {
    const scheduleId = paramsData?.cscCopayScheduleName;
    const description = await fetchScheduleDescription(scheduleId);
    if (description) {
      setParamsData((prevState) => ({
        ...prevState,
        cshCopayScheduleDesc: description,
      }));
    }
  };

  useEffect(() => {
    if (selectMode ) {
      initializeDescription();
    }
  }, [selectMode, scheduleDesc]);

  /* Search form fields that needs to be shown for filtering */
  const formFields = [
    {
      fieldLabel: "Schedule",
      name: "cscCopayScheduleName",
      label: "Schedule",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 10,
    },
    {
      fieldLabel: "Description",
      name: "cshCopayScheduleDesc",
      label: "Description",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 25,
    },
    {
      fieldLabel: "Note ValuesYes or No",
      name: "noteExistenceStatus",
      label: "Notes Exist",
      type: "dropdown",
      fieldNature: "readOnly",
      value: "",
      maxLength: 10,
    },
    {
      fieldLabel: "CSC Step Nbr",
      name: "cscStepNbr",
      label: "Step",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 2,
    },
  ];

  const handleBack = () => {
    if (externalMode) {
            const message = {
        message: "navigate-to-external-program",
        url: previousScreen,
        parameters: {
          state: [...previousState],
        },
      };
      console.log("back messages", message);
      window.parent.postMessage(message, "*");
    } else if (selectMode) {
      if (lookupType === "external") {
        if (interLinkedLookup) {
          const { previousScreen, previousState } = interLinkedLookup;
          if (previousScreen && previousState) {
            let newPreviousState = [...previousState];
            const lastPrevStateElement = newPreviousState.pop();
            newPreviousState = [
              ...newPreviousState,
              {
                ...lastPrevStateElement,
                interLinkedLookupState: {
                  ...lastPrevStateElement.interLinkedLookupState,
                  isPassedExternalParams: true,
                },
              },
            ];
            return navigateToPage(previousScreen, newPreviousState);
          }
        }
        window.parent.postMessage(
          {
            type: "hideModal",
          },
          "*"
        );
      } else {
        hideModal();
      }
    } else if (currentIndex < selectedSchedules.length - 1) {
      setCurrentIndex((prevIndex) => prevIndex + 1);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  };

  /* Top Left Back button info that needs to be displayed on the page*/
  const leftButtons = [
    { button_label: "Back", button_handeler: handleBack, button_key: "F12" },
  ];

  /* Dropdown options fields that needs to be fetched with API */
  const dropdownOptions = [
    { field_label: "Note Values", condition: "Yes or No" },
  ];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  /* ACTION BUTTONS info that needs to be displayed on the page */
  const ctaButtons = selectMode
    ? [
        {
          button_label: "Export as CSV",
          button_handeler: () => {
            exportAsCSV();
          },
          button_key: "",
        },
      ]
    : [
        {
          button_label: "Add Copay Schedule Step",
          button_handeler: () => {
            navigateToPage(ROUTE_PATHS.COPAY_SCHEDULE_STEPS_ADD, [
              ...previousState,
              { ...currentState, paramsData: paramsData, currentIndex,externalMode },
              {
                previousScreen: location.pathname,
                cscCopayScheduleName: paramsData.cscCopayScheduleName,
                cshCopayScheduleDesc: paramsData.cshCopayScheduleDesc,
              },
            ]);
          },
          button_key: "F6",
        },
        {
          button_label: "Note",
          button_handeler: () => {
            navigateToPage(COPAY_SCHEDULE_NOTE, [
              ...previousState,
              { ...currentState, currentIndex, externalMode },
              {
                selectedCopaySchedules: [selectedSchedules[currentIndex]],
                previousScreen: location.pathname,
              },
            ]);
          },
          button_key: "F14",
        },
        {
          button_label: "Export as CSV",
          button_handeler: () => {
            exportAsCSV();
          },
          button_key: "",
        },
      ];

  /* Gear Icon Menu option CTAs */
  const menuOptions = selectMode
    ? [
        {
          label: "Select",
          icon: <span className="material-icons">add</span>,
          command: () => {
            const paramDataMap = new Map();

            selectParams.forEach((key) => {
            // Validate and sanitize the source key
            const safeSourceKey = typeof key["source"] === "string"
              ? key["source"].replace(/[^a-zA-Z0-9_]/g, "") // Allow only alphanumeric and underscores
              : null;

            if (safeSourceKey) {
              if (key["target"] === "cshCopayScheduleId") {
                  paramDataMap.set(safeSourceKey, paramsData.cscCopayScheduleName);
              } else if (rowData.hasOwnProperty(key["target"])) {
                  paramDataMap.set(safeSourceKey, rowData[key["target"]]);
                }
              }
            });
            const paramData = Object.fromEntries(paramDataMap);
            if (lookupType === "local") {
              onSelect(paramData);
            } else if (lookupType !== "external") {
              onSelect(paramData);
              setFalg(true);
            } else {
              const allowedSourceKeys = selectParams.map(item => item.source);
              const sourecDescKey =
              selectParams.find(
                (item) => item.target === "cshCopayScheduleDesc"
              ) || "";
              const safeSourceKey = allowedSourceKeys.includes(sourecDescKey.source) ? sourecDescKey.source : null;
              window.parent.postMessage(
                {
                  type: "responseData",
                  data: {
                    ...paramData,

                        //  [sourecDescKey.source]:
                        //    paramsData?.cshCopayScheduleDesc,
                       // }

                       ...(sourecDescKey
                         ? {
                             [safeSourceKey]: paramsData?.cshCopayScheduleDesc,
                           }
                      : {}),
                  },
                },
                "*"
              );
            }
          },
        },
        {
          label: "Display",
          icon: <span className="material-icons">visibility</span>,
          command: () => {
            /* const message = {
              message: "navigate-to-presto",
              programCode: "RCCSC007I",
              parameters: {
                cshCopayScheduleDesc: rowData["cshCopayScheduleDesc"],
                cscStepNbr: rowData["cscStepNbr"],
                cscCopayScheduleName: rowData["cscCopayScheduleName"],
              },
            };
            console.log(message, "message");
            window.parent.postMessage(message, "*");
            */
            if (lookupType === "local") {
            onNavigate({
              data: {
                ...rowData,
              },
              target: ROUTE_PATHS.COPAY_SCHEDULE_STEPS,
              navType: "local",
              additionalData: {
                paramsData: { ...paramsData, cscStepNbr: rowData.cscStepNbr },
              },
            });

          }  else{
              if (interLinkedLookup) {
                const { isLookupPrepopulated = false } = interLinkedLookup;
                if (!isLookupPrepopulated) {
                  window.sessionStorage.setItem("interLinkedLookup", JSON.stringify(interLinkedLookup));
                }
              }
              const params = selectParams || [];
              const paramDataMap = new Map();
              params.forEach(item => {
                  if (rowData.hasOwnProperty(item["target"])) {
                    paramDataMap.set(item["source"], rowData[item["target"]]);
                  }
              });
              const paramData = Object.fromEntries(paramDataMap);

              const additionalData = {
                paramsData: {
                  ...paramsData,
                  cshCopayScheduleDesc: rowData.cshCopayScheduleDesc,
                  cscStepNbr: rowData.cscStepNbr,
                },
              };
              const message = {
                type: "navigateData",
                data: { ...rowData, cshCopayScheduleDesc: rowData.cshCopayScheduleDesc },
                target: "COPAY_SCHEDULE_STEPS_READ_ONLY",
                schedulesDataKey: "selectedSchedules",
                ...(interLinkedLookup && {externalParams:{
                  lookupType: "external",
                  viewType: "external",
                  fieldMapping: {
                      default: selectParams
                  },
                  appName: "PATIENT_PAY",
                  pageName: "COPAY_SCHEDULE_STEPS",
                }}),
                additionalData
              };
              console.log("display message", message);
              window.parent?.postMessage(message, "*");
            }
          },
        },
      ]
    : [
        {
          label: "Edit",
          icon: <span className="material-icons">edit</span>,
          command: () => {
            const selectedSchedulesCount = selectedRows.length;
            const { cscStepNbr } = selectedSchedulesCount
              ? selectedRows[selectedSchedulesCount - 1]
              : rowData;

            navigateToPage(ROUTE_PATHS.COPAY_SCHEDULE_STEPS_EDIT, [
              ...previousState,
              {
                ...currentState,
                currentIndex,
                paramsData: { ...paramsData, cscStepNbr: cscStepNbr },
                externalMode
              },
              {
                selectedSchedules: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
                cscCopayScheduleName: paramsData.cscCopayScheduleName,
                cshCopayScheduleDesc: paramsData.cshCopayScheduleDesc,
              },
            ]);
          },
        },
        {
          label: "Delete",
          icon: <span className="material-icons">delete</span>,
          command: () => {
            openConfirmationModal();
          },
        },
        {
          label: "Display",
          icon: <span className="material-icons">visibility</span>,
          command: () => {
            const selectedSchedulesCount = selectedRows.length;
            const { cscStepNbr } = selectedSchedulesCount
              ? selectedRows[selectedSchedulesCount - 1]
              : rowData;
            navigateToPage(ROUTE_PATHS.COPAY_SCHEDULE_STEPS_DISPLAY, [
              ...previousState,
              {
                ...currentState,
                currentIndex,
                paramsData: { ...paramsData, cscStepNbr: cscStepNbr },
                externalMode
              },
              {
                selectedSchedules: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
                cscCopayScheduleName: paramsData.cscCopayScheduleName,
                cshCopayScheduleDesc: paramsData.cshCopayScheduleDesc,
              },
            ]);
          },
        },
      ];

  /* Data table column info. */
  const columnDef = [
    {
      header: "Step",
      field: "cscStepNbr",
    },
    {
      header: "Basis",
      field: "cscBasis",
    },
    {
      header: "Step Maximum $Amt/Qty/day",
      field: "fscMaxAmtQty",
    },
    {
      header: "Step Days Supply",
      field: "cscDaysSupply",
    },
    {
      header: "Copay $Amount/Factor",
      field: "cscAmtFactor",
    },
    {
      header: "Copay Percent",
      field: "cscPercent",
    },
    {
      header: "Maximum Copay $ Amount",
      field: "cscMaximumCopay",
    },
    {
      header: "Maximum Copay Percent",
      field: "cscMaximumCopayPercent",
    },
    {
      header: "Maximum Copay Basis",
      field: "cscMaxCopayCalcBasis",
    },
    {
      header: "Maximum Copay Overage",
      field: "cscMaxCopayOverage",
    },
    {
      header: "Patient Pay O/R Comparison Code",
      field: "cscCopayCompCodeOvrrd",
    },
    {
      header: "Patient Pay O/R Minimum",
      field: "cscMinimumCopayOverride",
    },
  ];

  /* Param Key which used as bridge between various operations on tabluar data */
  const parmKey = "cscStepNbr";

  /* Handler that fetches the data */
  const fetchData = async () => {
    console.log("fetch data");
    const page = first / rows;
    console.log("paramsData: ", paramsData);
    try {
      if(paramsData && paramsData?.cscCopayScheduleName){
        const raw_response = await axios_helper_no_header(
        "GET",
        `api/cscCopaySchedule`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        console.log("response.length is ", response.length);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        console.log("response", response);
        console.log(pageResponse.totalRecords);
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords
      }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
          fetchDataCallOnInitialLoad(fetchData, lookupType); // Initial fetch with page 0 and page size 10
  }, [paramsData, rows, currentPage, lookupType]);
  useEffect(() => {
    if (initialIndex !== currentIndex) {
      setParamsData({
        cscCopayScheduleName: selectMode
          ? scheduleDesc.cshCopayScheduleId
          : selectedSchedules[currentIndex]?.cshCopayScheduleId,
        cshCopayScheduleDesc: selectMode
          ? scheduleDesc.cshCopayScheduleDesc
          : selectedSchedules[currentIndex]?.cshCopayScheduleDesc,
        cscStepNbr: null,
      });
    }
    if(selectedSchedules.length){
   
        setParamsData({
          cscCopayScheduleName:  selectedSchedules[currentIndex]?.cshCopayScheduleId,
          cshCopayScheduleDesc:  selectedSchedules[currentIndex]?.cshCopayScheduleDesc,
          cscStepNbr: null,
        });
    
    }
  }, [currentIndex, selectMode, intialSchedule, initialIndex,lookupType,selectedSchedules,currentState,selectMode,currentIndex]);
  useEffect(() => {
    if (paramsData?.cshCopayScheduleDesc) {
      getNotesExistenceStatus();
    }
  }, [selectMode, paramsData?.cshCopayScheduleDesc]);

  const onPageChange = (event) => {
    console.log("page change", event.first, event);
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deleteCopayScheduleStep = () => {
    if (selectedOption === "yes") {
      const params = {
        cscCopayScheduleName: rowData["cscCopayScheduleName"],
        cscStepNbr: rowData[parmKey],
      };
      axios_helper_no_header("DELETE", "api/cscCopaySchedule", null, params)
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
          if (currentPage > 0) {
            setFirst(0);
            setCurrentPage(0);
          } else {
            fetchData();
          }
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          const {
            responseStatus: { displayErrorFields = null, message } = {},
          } = error.data;
          toast.current.show({
            severity: "error",
            summary: "",
            detail: message,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const filteredParams = Object.fromEntries(
      Object.entries(paramsData).filter(([key, value]) => value != null)
    );
    const queryParams = new URLSearchParams({
      ...filteredParams,
      screenNumber: screenNumber,
    });

    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/cscCopaySchedule/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  const getNotesExistenceStatus = async () => {
    console.log("note params data", paramsData);
    const raw_response = await axios_helper_no_header(
      "GET",
      `api/cscCopaySchedule/notesExistenceStatus`,
      null,
      {
        ...paramsData,
      }
    );
    const response = raw_response.responseData;
    setParamsData({ ...paramsData, noteExistenceStatus: response });
  };

  useEffect(() => {
    if (interLinkedLookup) {
      const {
        externalProgram: { default: externalScreenNumber },
        params: {
          fieldMapping: { default: externalSelectParams },
        },
        selectedItem: {
          cshCopayScheduleDesc = "",
          cshCopayScheduleId = "",
          cscStepNbr = null,
        },
      } = interLinkedLookup;
      setSelectParams(externalSelectParams);
      setScreenNumber(externalScreenNumber);
      setParamsData({
        ...paramsData,
        cscCopayScheduleName: cshCopayScheduleId,
        cshCopayScheduleDesc,
        cscStepNbr,
      });
      setLookupType("external");
      setSelectedMode("true");
    }
  }, [interLinkedLookup]);

  const handleMessage = (event) => {
    const { type, data } = event.data;
    console.log("iframe load", type, data);
    if (type === "initData") {
      const { selectMode, data: paramData, params } = data;
      console.log("external data", data);
      setLookupType("external");
      if (paramData.paramsData) {
        setParamsData((prevParamsData) => {
          const newParamsData = {
            ...prevParamsData,
            ...paramData.paramsData,
          };
          if (newParamsData.cscCopayScheduleName) {
            fetchScheduleDescription(newParamsData.cscCopayScheduleName).then((description) => {
              if (description) {
                setParamsData((prevState) => ({
                  ...prevState,
                  cshCopayScheduleDesc: description,
                }));
              }
            });
          }
          return newParamsData;
        });
      }
      setSelectedPatient([...paramData.selectedSchedule]);
      setSelectedMode(selectMode);
      setSelectParams(paramData.params);
    }
   else if (type === "set-params") {
      setStateVal(data);
      setExternalMode(true);
    }
    console.log("message", event.data);
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    const interLinkedLookupSession = window.sessionStorage.getItem("interLinkedLookup");
    if (interLinkedLookupSession) setInterLinkedLookup(JSON.parse(interLinkedLookupSession));
    window.sessionStorage.removeItem("interLinkedLookup");
    return () => window.removeEventListener("message", handleMessage);
  });


  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    leftButtons,
    ctaButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deleteCopayScheduleStep,
    setSelectedOption,
    selectMode,
  };
};

export default useCopayScheduleStep;
